import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch {
      /* anti-enumeration: backend always 200; ignore errors */
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-8" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="font-display text-2xl mb-8 inline-block">AfriMarket</Link>
        {sent ? (
          <div data-testid="forgot-sent">
            <div className="w-12 h-12 rounded-full bg-[#4A5D23]/10 flex items-center justify-center mb-4">
              <MailCheck className="w-6 h-6 text-[#4A5D23]" />
            </div>
            <h1 className="font-display text-3xl mb-2">Check your inbox</h1>
            <p className="text-muted-foreground text-sm mb-8">
              If an account exists for <span className="font-medium text-foreground">{email}</span>, we&apos;ve sent
              a link to reset your password. It expires in 30 minutes. Don&apos;t forget to check your spam folder.
            </p>
            <Link to="/login" className="text-[#C05A3C] font-medium hover:underline text-sm" data-testid="back-to-login">
              ← Back to log in
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl mb-2">Forgot your password?</h1>
            <p className="text-muted-foreground text-sm mb-8">
              Enter the email you signed up with and we&apos;ll send you a link to set a new password.
            </p>
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div>
                <Label htmlFor="email" className="label-overline">Email</Label>
                <Input
                  id="email"
                  data-testid="forgot-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-2"
                  placeholder="you@example.com"
                />
              </div>
              <Button type="submit" disabled={loading} className="w-full h-12 bg-[#C05A3C] hover:bg-[#D46B4E] rounded-md" data-testid="forgot-submit">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
              </Button>
            </form>
            <p className="text-sm text-muted-foreground mt-6">
              Remembered it? <Link to="/login" className="text-[#C05A3C] font-medium hover:underline" data-testid="link-login">Log in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
